import { render, staticRenderFns } from "./JdsSheet.vue?vue&type=template&id=d74a3480&scoped=true&"
import script from "./JdsSheet.vue?vue&type=script&lang=ts&"
export * from "./JdsSheet.vue?vue&type=script&lang=ts&"
import style0 from "./JdsSheet.vue?vue&type=style&index=0&id=d74a3480&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74a3480",
  null
  
)

export default component.exports